var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.feather_een{fill:#0B1719;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "feather_een",
    d: "M29.906,12.916c0.799-0.349,0.799-1.483,0-1.832L17.202,5.526C16.819,5.358,16.41,5.275,16,5.275 c-0.41,0-0.819,0.084-1.202,0.252L2.094,11.084c-0.799,0.35-0.799,1.483,0,1.832L8,15.5v3.32c0,1.136,0.642,2.175,1.658,2.683l0,0 C11.655,22.501,13.827,23,16,23s4.345-0.499,6.341-1.497l0,0C23.358,20.995,24,19.956,24,18.82V15.5l4-1.75V21c-0.552,0-1,0.448-1,1 v3c0,0.552,0.448,1,1,1h1c0.552,0,1-0.448,1-1v-3c0-0.552-0.448-1-1-1v-7.688L29.906,12.916z M23,18.82 c0,0.762-0.424,1.448-1.106,1.789C20.074,21.519,18.035,22,16,22s-4.074-0.481-5.894-1.391C9.424,20.268,9,19.582,9,18.82v-2.882 l5.798,2.536c0.383,0.168,0.793,0.252,1.202,0.252c0.41,0,0.819-0.084,1.202-0.252L23,15.937V18.82z M16.802,17.558 c-0.254,0.111-0.524,0.168-0.802,0.168s-0.547-0.056-0.802-0.168L2.495,12l12.703-5.558C15.453,6.331,15.722,6.275,16,6.275 s0.547,0.056,0.802,0.168L29.505,12l-1.118,0.489L16.894,11.57C16.732,11.235,16.396,11,16,11c-0.552,0-1,0.448-1,1 c0,0.552,0.448,1,1,1c0.337,0,0.621-0.178,0.802-0.434l9.646,0.772L16.802,17.558z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.1b6ca561800b9a677f851423d198c4ec.svg";
export { ForwardRef as ReactComponent };